<!-- <div class="main-div">
    <div class="featured-properties">
        <div class="featured-properties-heading">Featured Properties</div>

    </div>
    <div class="properties-box-section">
        <div class="row">
            <div class="properties-box" *ngFor="let properties of featuredProperties" (click)="openProjectView(properties)">
                <img [src]="properties.galleryPics[0].objectUrl" alt="img" >
                <div class="row property-custom-box">
                    <div class="col property-details-blockone">
                        <p class="property-name">{{properties.projectName}}</p>
                        <p class="property-address">{{properties.address.locality}}, {{properties.address.city}}</p>
                        <p class="property-designation">{{properties.projectBy}}</p>
                        <p class="property-designation" [innerHTML]="properties.description"></p>
                    </div>
                    <div class="col property-type-block">
                        <div class="property-type">{{properties.subcategoryName}}</div>
                        <div class="property-price" *ngIf="properties.units?.length > 0">{{properties.formattedPrice}}*<span>onwards</span></div>
                        <div class="property-price" *ngIf="properties.units?.length===0"> ₹ {{getTotalAsset(properties?.minimumPrice,properties?.size?.value) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->




<div class="container-fluid  ">
  <div class="featured-properties-heading mt-4 mb-5 ">Featured Properties</div>
  <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4  row-cols-xxl-4 g-4 ">
    <div class="col" *ngFor="let properties of featuredProperties" (click)="openProjectView(properties)">
      <div class="card h-100 shadow-md border-0">
        <!-- Property Image -->
        <img
          class="img-fluid rounded-top property-img"
          [src]="properties.galleryPics[0]?.objectUrl"
          alt="{{ properties.projectName }}"
        />

        <!-- Card Body -->
        <div class="card-body d-flex flex-column justify-content-between" style="cursor: pointer;">
            <!-- Project Name and Price Row -->
            <div class="mb-2">
              <div class="row align-items-center">
          <div class="col-7 pe-0">
            <h5 class="card-title fw-bold text-black  mb-0" title="{{properties.projectName}}">
              {{ properties.projectName }}
            </h5>
          </div>
          <div class="col-5 ps-0 text-end">
            <span class="fw-semibold fs-6 text-black mb-0">
              <ng-container *ngIf="properties.units?.length > 0">
          {{ properties.formattedPrice }}* <small class="text-muted">onwards</small>
              </ng-container>
              <ng-container *ngIf="properties.units?.length === 0">
          ₹ {{ getTotalAsset(properties?.minimumPrice, properties?.size?.value) }}
              </ng-container>
            </span>
          </div>
              </div>
            </div>

         <div class="position-absolute top-0 end-0 m-2">
  <!-- Show spinner if loading -->
  <div *ngIf="loadingFavorites[properties._id]; else heartIcon">
    <div class="spinner-border text-primary" role="status" style="width: 1.5rem; height: 1.5rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Heart icon when not loading -->
  <ng-template #heartIcon>
    <fa-icon [icon]="faHeart"
             class="favorite-icon"
             [ngClass]="{'favorite': properties.favProperty}"
             (click)="toggleFavorite($event, properties)"
             *ngIf="!isAdmin"
             [ngbTooltip]="'Save'">
    </fa-icon>
  </ng-template>
</div>

            <!-- Subcategory -->
            <div class="row mb-1">
            <div class="col">
              <span class="text-uppercase fw-semibold text-muted small">{{ properties.subcategoryName }}</span>
            </div>
            </div>

            <!-- Location & Developer -->
            <div class="row mb-1">
            <div class="col">
              <span class="text-secondary">
              <i class="bi bi-geo-alt"></i>
              {{ properties.address.locality }}, {{ properties.address.city }}
              </span>
            </div>
            </div>
            <div class="row mb-2">
            <div class="col">
              <span class="text-muted small">{{ properties.projectBy }}</span>
            </div>
            </div>

            <!-- Description -->
            <div class="row">
            <div class="col">
             <div class="description-wrapper">
        <div class="inner-html-content text-muted" [innerHTML]="properties.description"></div>
            </div>


            </div>
            </div>


        </div>
      </div>
    </div>
  </div>

</div>
<div *ngIf="!checkLoginStatus">
    <app-login-popup [isVisible]="isLoginModalVisible" (closeModal)="closeProjectModal()"></app-login-popup>
</div>


